<template>
  <a-popover
    trigger="click"
    overlayClassName="l8-order-popover order-primary-popover"
    placement="bottom"
  >
    <template slot="content">
      <template v-if="ifInternational">
        <div class="popover-detail-table">
          <table>
            <tr>
              <td>票面价</td>
              <td>{{ passenger.totalFare | amount }} 元</td>
            </tr>
            <!-- 税费总合 -->
            <!-- <tr>
              <td>税费</td>
              <td>{{ passenger.totalTax | amount }}元</td>
            </tr> -->
            <tr v-for="tax in passenger.taxs" :key="tax.code">
              <td>{{ inTaxMap[tax.code] }}</td>
              <td>{{ tax.amount | amount }} 元</td>
            </tr>
            <tr v-for="acl in passenger.allAncillaries" :key="acl.id">
              <template v-if="acl.productType === 'INSURANCE' && ['RF', 'XX', 'SS', 'OF', 'SB'].indexOf(acl.status) < 0" >
                <td>{{ acl.productName }}</td>
                <td>{{ acl.amount | amount }}元</td>
              </template>
              <template v-else-if="acl.productType !== 'ITINERARY' && ['XX', 'RF'].indexOf(acl.status) < 0" >
                <td>{{ getAclName(acl.productType) }}</td>
                <td>{{ acl.amount | amount }}元</td>
              </template>
            </tr>
          </table>
        </div>
        <div class="popover-detail-footer">
          <div class="popover-detail-price">
            总额：{{ (Number(passenger.totalFare) + Number(passenger.totalTax) + Number(passenger.totalAncillaryFare)) | amount }} 元
          </div>
        </div>
      </template>
      <template v-else>
        <div class="popover-detail-table">
          <table>
            <tr>
              <td>票面价</td>
              <td>{{ (Number(segment.netFare) + Number(segment.couponAmount) + Number(segment.pointAmount)) | amount }}元</td>
            </tr>
            <tr>
              <td>民航发展基金</td>
              <td>{{ segment.airportTax | amount }}元</td>
            </tr>
            <tr>
              <td>燃油</td>
              <td>{{ segment.fuelTax | amount }}元</td>
            </tr>
            <tr v-for="(acl, aclIndex) in segment.ancillaries" :key="aclIndex">
              <template
                v-if="
                  acl.productType === 'INSURANCE' &&
                  ['RF', 'XX', 'SS', 'OF', 'SB'].indexOf(acl.status) < 0
                "
              >
                <td>{{ acl.productName }}</td>
                <td>{{ acl.amount | amount }}元</td>
              </template>
              <template
                v-else-if="
                  acl.productType !== 'ITINERARY' &&
                  ['XX', 'RF'].indexOf(acl.status) < 0
                "
              >
                <td>{{ getAclName(acl.productType) }}</td>
                <td>{{ acl.amount | amount }}元</td>
              </template>
            </tr>
            <tr v-if="Number(segment.couponAmount)">
              <td>优惠券</td>
              <td>{{ -Number(segment.couponAmount) | amount }}元</td>
            </tr>
             <tr v-if="Number(segment.pointAmount)">
              <td>金鹏会员积分抵扣</td>
              <td>{{ -Number(segment.pointAmount) | amount }}元</td>
            </tr>
          </table>
        </div>
        <div class="popover-detail-footer">
          <div class="popover-detail-price">
            总额：{{ +segment.totalAmount | extAmount(segment) }}元
          </div>
        </div>
      </template>
    </template>
    <template slot="title">
      <span>总票价</span>
    </template>
    <span v-if="ifInternational">
      <span class="v-m"
        >总票价：
        {{ (+passenger.totalFare + passenger.totalTax + passenger.totalAncillaryFare) | amount }} 元 </span
      ><l8-icon class="l8-icon v-m" type="icon-sanx-up" />
    </span>
    <span v-else>
      <span class="v-m">
        {{ +segment.totalAmount | extAmount(segment) }}元 </span
      ><l8-icon class="l8-icon v-m" type="icon-sanx-up" />
    </span>
  </a-popover>
</template>
<script>
import { inTaxMap } from '@/dicts/order'
import { sumBy } from 'lodash'
export default {
  props: {
    passenger: {
      type: Object,
      default: () => {
        return {}
      }
    },
    segment: {
      type: Object,
      default: () => {
        return {}
      }
    },
    ifInternational: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      inTaxMap
    }
  },
  methods: {
    getAclName (name) {
      const aclNameMap = {
        LUGGAGE: '预付费行李',
        MEAL: '付费餐食',
        SEAT: '预选座位'
      }

      return aclNameMap[name]
    }
  },
  filters: {
    extAmount (amount, segment) {
      const extAmount = sumBy(segment.ancillaries, (acl) => {
        if (acl.productType !== 'ITINERARY') {
          if (
            acl.productType === 'INSURANCE' &&
            ['RF', 'XX', 'SS', 'OF', 'SB'].indexOf(acl.status) < 0
          ) {
            return +acl.amount
          } else if (['XX', 'RF'].indexOf(acl.status) < 0) {
            return +acl.amount
          } else {
            return 0
          }
        }
      })
      const total = amount + extAmount
      return (+total).toFixed(2)
    }
  }
}
</script>
